import React from "react";
import MDInput from "../../../components/MDInput";
import MenuItem from '@mui/material/MenuItem';

export function filterType(column, gotoPage) {

    if (column.filterType == "date") {
        column.setFilter = test
    }

    switch (column.filterType) {
        case "text": return <TextSearchFilter column={column} gotoPage={gotoPage} />
        case "select": return <DropdownFilter column={column} gotoPage={gotoPage} />
        case "date": return <DateFilter column={column} gotoPage={gotoPage} />
        default: return null;
    }
}

function TextSearchFilter({ column: { filterValue, preFilteredRows, setFilter }, gotoPage }) {

    return (
        <MDInput
            value={filterValue || ""}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            onChange={(e) => {
                setFilter(e.target.value || undefined);
                gotoPage(0);
            }}
            placeholder={`Cerca`}
            size="small"
            variant="standard"
            sx={{width:"100%"}}
        />
    );
}

function DropdownFilter({ column: { filterValue, setFilter, preFilteredRows, id }, gotoPage }) {
    const options = React.useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach((row) => {
            options.add(row.values[id]);
        });
        return [...options.values()];
    }, [id, preFilteredRows]);

    return (
        <MDInput
            select
            value={filterValue}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            onChange={(e) => {
                setFilter(e.target.value || undefined);
                gotoPage(0);
            }}
            fullWidth
            variant="standard"
            size="small"
        >
            <MenuItem value={""}>Tutti</MenuItem>
            {options.map((option, i) => (
                <MenuItem value={option} key={"select-" + option + "-" + i}>{option}</MenuItem>
            ))}
        </MDInput>
    );
}


function test(val,b,c) {
    //console.log(val,b,c);
}

export function DateFilter({ column: { filterValue, setFilter, preFilteredRows, id, customFilter }, gotoPage }) {



    return (
        <div style={{display:"flex"}}>
            <MDInput
                type="number"
                value={filterValue}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onChange={(e) => {
                   // const val = e.target.value;
                    setFilter(e.target.value);
                    gotoPage(0);
                }}
                fullWidth
                variant="standard"
                size="small"
            />

        </div>
    );
}
